/* import __COLOCATED_TEMPLATE__ from './attribute-descriptor-option.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();